<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="800">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
            <span class="px-3">{{ $t('View Product Information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <v-layout row wrap class="invoice-content">
            <v-flex xs12 style="text-align: center" class="only-for-print" pb-3>
              <strong>{{ $t('Product') }}</strong>
            </v-flex>

            <v-flex xs12 sm4 mb-2>
              <v-layout column style="margin:0 auto; max-width:calc(100% - 20px);">
                <v-flex xs12>
                  <a v-if="productInfo.product_image" @click="dialogs.imageViewerDialog = true">
                    <v-img :src="`${baseUrls.images}/${productInfo.product_image}`" height="250" />
                  </a>
                  <v-img class="not-printable" v-else :src="`${baseUrls.images}/no-image-available.png`" height="250" />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm8 :class="{ 'pt-2': $vuetify.breakpoint.xsOnly, 'px-2': true }">
              <v-layout row wrap>
                <v-flex xs12></v-flex>

                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">{{ $t('Product Name') }}</div>
                  <strong>{{ productInfo.product_name || '-' }}</strong>
                </v-flex>

                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">{{ $t('Barcode') }}</div>
                  <strong>{{ productInfo.product_barcode || '-' }}</strong>
                </v-flex>

                <!-- <v-flex xs6 class="pb-3">
                  <div class="caption no-select">{{ `${$t('Average Price')} (${systemCurrency})` }}</div>
                  <strong
                    v-if="productInfo.product_average_price"
                  >{{ productInfo.product_average_price | currency }}</strong>
                  <strong v-else>-</strong>
                </v-flex>-->

                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">
                    {{ `${$t('Sale Price')} (${systemCurrency})` }}
                  </div>
                  <strong v-if="productInfo.product_sale">{{ productInfo.product_sale | currency }}</strong>
                  <strong v-else>-</strong>
                </v-flex>

                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">{{ $t('Product Type') }}</div>
                  <strong>{{ productInfo.product_type_name || '-' }}</strong>
                </v-flex>

                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Quantity Alarm') }}
                  </div>
                  <strong>{{ productInfo.quantity_alarm || '-' }}</strong>
                </v-flex>

                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Total Quantity Alarm') }}
                  </div>
                  <strong>{{ productInfo.quantity_alarm_total || '-' }}</strong>
                </v-flex>

                <!-- <v-flex xs12 class="pb-3">
                  <div
                    class="caption no-select"
                  >{{ $t('Expiration Alarm (No. of days before expiry)') }}</div>
                  <strong>{{ productInfo.expire_alarm || '-' }}</strong>
                </v-flex>-->

                <v-flex xs12 pb-2>
                  <div class="caption no-select">
                    {{ $t('Brand / Made In') }}
                  </div>
                  <strong>{{ productInfo.brand_or_made_in || '-' }}</strong>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <!-- <v-flex xs12 class="pb-3 px-2">
              <div class="caption no-select">{{ $t('Product Tags') }}</div>
              <template v-if="productTags.length > 0">
                <strong v-for="(tag, index) in productTags" :key="index">
                  <v-chip>{{ tag }}</v-chip>
                </strong>
              </template>
              <strong v-else>-</strong>
            </v-flex>-->

            <v-flex xs6 pb-2 px-2>
              <div class="caption no-select">
                {{ $t('Product Can Be Sold') }}
              </div>
              <v-chip
                slot="activator"
                label
                :color="productInfo.can_be_sold === '1' ? 'success' : 'error'"
                text-color="white"
                class="no-select"
              >
                <v-icon class="not-printable">{{
                  productInfo.can_be_sold === '1' ? 'fa-check-circle' : 'block'
                }}</v-icon>
                <span class="only-for-print">{{ productInfo.can_be_sold === '1' ? $t('YES') : $t('NO') }}</span>
              </v-chip>
            </v-flex>

            <v-flex xs6 pb-2 px-2>
              <div class="caption no-select">
                {{ $t('Product Can Be Purchase') }}
              </div>
              <v-chip
                slot="activator"
                label
                :color="productInfo.can_be_purchase === '1' ? 'success' : 'error'"
                text-color="white"
                class="no-select"
              >
                <v-icon class="not-printable">{{
                  productInfo.can_be_purchase === '1' ? 'fa-check-circle' : 'block'
                }}</v-icon>
                <span class="only-for-print">{{ productInfo.can_be_purchase === '1' ? $t('YES') : $t('NO') }}</span>
              </v-chip>
            </v-flex>

            <v-flex
              xs12
              :class="{
                'pt-0 px-2': $vuetify.breakpoint.xsOnly,
                'pt-3 px-2': !$vuetify.breakpoint.xsOnly
              }"
            >
              <div class="caption no-select">{{ $t('Description') }}</div>
              <strong v-html="lnToBr(productInfo.product_description) || '-'" />
            </v-flex>

            <v-flex
              xs12
              style="margin-top: 20px; margin-bottom:20px"
              v-if="productInfo.collections && productInfo.collections.length > 0"
            >
              <v-layout row wrap justify-center mb-2>
                <v-flex xs3 ml-5>
                  <h3 style="text-align: center">
                    {{ `${productInfo.product_name} ${$t('Collections')}` }}
                  </h3>
                </v-flex>
                <v-flex xs10 ml-5 mr-5 mb-3>
                  <v-divider />
                </v-flex>
              </v-layout>
              <table class="printed-table" cellspacing="0">
                <thead>
                  <tr>
                    <th xs1 class="pa-2 view-table-header">#</th>
                    <th class="view-table-header" xs5 pa-2>
                      {{ $t('Name') }}
                    </th>
                    <th class="view-table-header" xs2 pa-2>
                      {{ `${$t('Price')} (${systemCurrency})` }}
                    </th>
                    <th class="view-table-header" xs2 pa-2>
                      {{ $t('Quantity') }}
                    </th>
                  </tr>
                </thead>
                <template>
                  <tbody>
                    <tr v-for="(row, index) in productInfo.collections" :key="index">
                      <td class="view-table-row">
                        <p class="view-table-content">{{ index + 1 }}</p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ row.collection_name }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ row.collection_price | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ row.collection_quantity | currency }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </template>
                <tfoot>
                  <tr class="only-for-print">
                    <td>
                      <div class="footer-space">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </v-flex>

            <invoice-footer
              :showSignatureSection="false"
              :accountantName="''"
              :payerRecipientName="''"
              :payerOrRecipient="''"
              class="only-for-print"
            />
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>

    <image-viewer
      :imageSrc="productInfo.product_image"
      :maxWidth="700"
      :imageViewerDialog="dialogs.imageViewerDialog"
      @hidemodal="dialogs.imageViewerDialog = false"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    imageViewer: () => import('@/views/_partials/AppImageViewer.vue'),
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      productTags: [],
      dialogs: {
        imageViewerDialog: false
      }
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      productInfo: 'products/getProductInfo',
      fullProductTypesList: 'productTypes/getFullProductTypesList',
      settings: 'configurations/getSystemSettings'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          let tags = this.productInfo.product_tag
          this.productTags = tags ? tags.split(',') : []
        }
      }
    }
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      helpers.doPrinting()
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
